import Plot from "react-plotly.js";

export function renderChart(chartJson, chartName) {
  if (!chartJson || Object.keys(chartJson).length === 0) {
    return (
      <div style={{ padding: "1rem", color: "#999" }}>
        No data available for {chartName}
      </div>
    );
  }

  try {
    return (
      <div style={{ width: "100%", height: "500px" }}>
        <Plot
          data={chartJson.data || []}
          layout={{
            ...chartJson.layout,
            autosize: true,
            height: 500,
          }}
          config={{ responsive: true, displayModeBar: true }}
          useResizeHandler
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    );
  } catch (err) {
    console.error(`Error rendering chart ${chartName}:`, err);
    return <div style={{ color: "red" }}>Error rendering {chartName}</div>;
  }
}
